// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background-color: var(--bg-col);
  color: var(--col-txt);
  font-family: var(--main-font), sans-serif;
  font-weight: 400;
  font-size: var(--txt-fontsize);
  line-height: var(--txt-lineheight);
}

*,
*:before,
*:after {
  font-family: inherit;
  font-size: inherit; /* 100% */
  line-height: inherit;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  vertical-align: baseline;
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0 auto;
  min-height: 100vh; /*it is assumed the same for <html>*/
  min-height: 100dvh; /* if supported */
  height: 100%;

  width: 100%;
  /* or max-width -- this avoids horizontal scroll bars */

  touch-action: manipulation; /* disable double tap to zoom on some browsers*/
  /* user-select: none; */
}

/*****************************************************/

/* || Generic */

body {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}

header,
main,
footer {
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
}

main {
  margin-top: 10vh;
  margin-bottom: 15vh;
}

main {
  flex: 1;
}

p {
  text-wrap: pretty; /*or balance */
}

ul,
ol {
  list-style: none;
}

a,
a:hover,
a:active,
a:visited {
  text-decoration: none;
  touch-action: none;
}

button {
  cursor: pointer;
}

/* when hover is supporte */
@media not all and (hover: none) {
  /* styles*/
}

/* tablet or larger, or landscape (vs portrait), 641px (phone), 961px (tablet) */
@media only screen and (min-width: 768px), (orientation: landscape) {
}

/* Customize scrollbars */
::-webkit-scrollbar {
  width: 4px; /* width of the entire scrollbar */
  height: 4px; /* height of the entire scrollbar */
}

::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}

::-webkit-scrollbar-thumb {
  background: #888; /* color of the scroll thumb */
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555; /* color of the scroll thumb on hover */
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/index.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB,EAAE,oCAAoC;EACvD,kBAAkB,EAAE,iBAAiB;EACrC,YAAY;;EAEZ,WAAW;EACX,uDAAuD;;EAEvD,0BAA0B,EAAE,+CAA+C;EAC3E,uBAAuB;AACzB;;AAEA,sDAAsD;;AAEtD,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB,EAAE,cAAc;AACnC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,UAAU;AACZ;;AAEA,gFAAgF;AAChF;AACA;;AAEA,yBAAyB;AACzB;EACE,UAAU,EAAE,kCAAkC;EAC9C,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,uCAAuC;AAC3D","sourcesContent":["html {\r\n  background-color: var(--bg-col);\r\n  color: var(--col-txt);\r\n  font-family: var(--main-font), sans-serif;\r\n  font-weight: 400;\r\n  font-size: var(--txt-fontsize);\r\n  line-height: var(--txt-lineheight);\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  font-family: inherit;\r\n  font-size: inherit; /* 100% */\r\n  line-height: inherit;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  margin: 0;\r\n  vertical-align: baseline;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbody {\r\n  margin: 0 auto;\r\n  min-height: 100vh; /*it is assumed the same for <html>*/\r\n  min-height: 100dvh; /* if supported */\r\n  height: 100%;\r\n\r\n  width: 100%;\r\n  /* or max-width -- this avoids horizontal scroll bars */\r\n\r\n  touch-action: manipulation; /* disable double tap to zoom on some browsers*/\r\n  /* user-select: none; */\r\n}\r\n\r\n/*****************************************************/\r\n\r\n/* || Generic */\r\n\r\nbody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  overflow: auto;\r\n}\r\n\r\nheader,\r\nmain,\r\nfooter {\r\n  max-width: 100%;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n}\r\n\r\nmain {\r\n  margin-top: 10vh;\r\n  margin-bottom: 15vh;\r\n}\r\n\r\nmain {\r\n  flex: 1;\r\n}\r\n\r\np {\r\n  text-wrap: pretty; /*or balance */\r\n}\r\n\r\nul,\r\nol {\r\n  list-style: none;\r\n}\r\n\r\na,\r\na:hover,\r\na:active,\r\na:visited {\r\n  text-decoration: none;\r\n  touch-action: none;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\n/* when hover is supporte */\r\n@media not all and (hover: none) {\r\n  /* styles*/\r\n}\r\n\r\n/* tablet or larger, or landscape (vs portrait), 641px (phone), 961px (tablet) */\r\n@media only screen and (min-width: 768px), (orientation: landscape) {\r\n}\r\n\r\n/* Customize scrollbars */\r\n::-webkit-scrollbar {\r\n  width: 4px; /* width of the entire scrollbar */\r\n  height: 4px; /* height of the entire scrollbar */\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent; /* color of the tracking area */\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #888; /* color of the scroll thumb */\r\n  border-radius: 2px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555; /* color of the scroll thumb on hover */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
